module.exports = __webpack_public_path__ + "img/ApprovedByEdith.584e0291.jpg";